import { AccountAvatar, IPageTitleProps, PageTitle as RegularPageTitle } from '@michelin/acid-components';
import { runningOnCanvas } from '@michelin/central-provider/dist/utils/canvas';
import { setPageTitle } from 'Utils';
import useCustomer from 'hooks/useCustomer';
import usePermissionsSPP from 'hooks/usePermissionsSPP';
import React from 'react';

function SimpleLocationAvatar({ location }: {location: any}) {
  return (
    <div style={{
      borderRight: '1px solid #e0e0e0',
      paddingRight: 16,
      marginRight: 8,
      float: 'left',
    }}
    >
      <AccountAvatar
        accountType={location?.customer_type as any}
        name={location?.customer_dba_name || location?.customer_name || ''}
        accountNumbers={
        {
          shipTo: location?.ship_to_customer || undefined,
          billTo: location?.bill_to_customer || undefined,
          mdm: location?.mdm?.site_id || undefined,
        }
      }
        addressDisplay="cityState"
        address={{
          address1: location?.customer_addr1,
          address2: location?.customer_addr2,
          city: location?.customer_city,
          state: location?.customer_state,
          zip: location?.customer_zip,
        }}
      />
    </div>
  );
}

interface PageTitleProps extends IPageTitleProps {
  title: string | null | undefined;
  subtitle?: string | null;
}

export function PageTitle(props:PageTitleProps) {
  const permissions = usePermissionsSPP();
  const stLocation = useCustomer(permissions.stNumber || '');
  const { title, ...otherProps } = props;
  setPageTitle(`${title || ''}${props.subtitle ? ` - ${props.subtitle}` : ''}`);

  return (
    <div style={{ borderTop: runningOnCanvas() ? '1px solid rgba(0, 0, 0, 0.12)' : undefined }}>
      <RegularPageTitle
        title={(
          <>
            {runningOnCanvas() && <SimpleLocationAvatar location={permissions.location} />}
            {permissions.stNumber && (
              <SimpleLocationAvatar location={stLocation.data} />
            )}
            <div style={{ float: 'left', marginRight: props.rightItems ? 140 : undefined, marginTop: 2 }}>
              {title}
            </div>
          </>
        )}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...otherProps}
      />
    </div>
  );
}
